export default "<input type=\"password\" [attr.class]=\"defaultCss\" />"